var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewFlag)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('sr-header'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('sr-footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c5a3e70a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/index.vue
// module id = YLOT
// module chunks = 1